import { FlyoutMenu } from "@/components/General/FlyoutMenu/flyoutMenu";

export const FlyoutMenuDefault = () => {
    return (
        <FlyoutMenu>
            <FlyoutMenu.Categories>
                <FlyoutMenu.Category>
                    <FlyoutMenu.Category.Title />
                    <FlyoutMenu.Category.Links>
                        <FlyoutMenu.Category.Link />
                    </FlyoutMenu.Category.Links>
                </FlyoutMenu.Category>
            </FlyoutMenu.Categories>
        </FlyoutMenu>
    );
};
